import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('addButton');

    return {
        CAPTION_TEXT: t('captionText')
    };
};

export default useTranslation;
